<template>
    <div class="col-md-12">
        <form @submit.prevent="addProduct">
            <div class="h2">Add new product</div>
            <div class="container-fluid bg-light py-3">
                <div class="messages"></div>
                <div class="controls">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="product.name=='' && isSubmit? 'border-danger':''">
                                    <input type="text" autocomplete="off" required
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Product name"
                                           v-model="product.name">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="product.description=='' && isSubmit? 'border-danger':''">
                                            <textarea required class="form-control border-0 py-0 shadow-none form-input"
                                                      v-model="product.description"
                                                      placeholder="Product description"></textarea>
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="product.type=='' && isSubmit? 'border-danger':''">
                                    <select required class="form-control border-0 py-0 shadow-none pr-5"
                                            v-model="product.type">
                                        <option value="1">Product</option>
                                        <option value="2">Hourly product</option>
                                        <option value="3">Warehouse product</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="product.price_type=='' && isSubmit? 'border-danger':''">
                                    <select required class="form-control border-0 py-0 shadow-none pr-5"
                                            v-model="product.price_type">
                                        <option value="1">One time</option>
                                        <option value="2">Hourly product</option>
                                        <option value="3">Daily product</option>
                                        <option value="4">Weekly product</option>
                                        <option value="5">Monthly product</option>
                                        <option value="6">Quarterly product</option>
                                        <option value="7">Yearly product</option>
                                    </select>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>

                <div class="row">
                    <div class="col-md-12">
                        <button type="submit" class="btn btn-primary btn-lg" @click="validation()">Save</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-muted"></p>
                    </div>
                </div>
            </div>
        </form>
        <a href="/products" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>

    </div>
</template>

<script type="text/ecmascript-6">

export default {
    name: "ProductCreate",
    data() {
        return {
            type: '1',
            price_type: 'one-time',
            product: {},
            isSubmit: false
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        addProduct() {
            let uri = '/products';
            axios.post(uri, this.product).then((response) => {
                window.location.href = `/products`;
            }).catch(err => console.log(err))
        }
    }
}

</script>
